import MetaBase from "@dojo/framework/core/meta/Base";

/**
 * Meta to get CSS matrix
 */
class GetCSSMatrix extends MetaBase {
	/**
	 * get css matrix for node with given key
	 * @param key key to node
	 */
	public get(key: string): DOMMatrix {
		const matrix: DOMMatrix = new DOMMatrix();
		const node = this.getNode(key) as HTMLElement;
		if (node && node.style) {
			const styles = window.getComputedStyle(node);
			if (styles.transform) {
				return new DOMMatrix(styles.transform);
			}
		}
		return matrix;
	}
}

export default GetCSSMatrix;
